<template>
  <div class="field-show-select-container">
    <template v-if="[3, 5].includes(fieldsInfo?.fieldType)">
      <!-- 多选 -->
      <xl-table-popover :styleInfo="fieldsInfo?.fieldExt" :value="fieldsInfo?.fieldValue" :sourceType="params.sourceType" />
    </template>
    <template v-else>
      <!--线索、线索池、客户 跟进建议  -->
      <template v-if="fieldsInfo?.fieldKey == 'intentionality'">
        <xl-dot :title="fieldsInfo?.fieldValue" :color="adviceColors[fieldsInfo?.fieldValue]" v-if="fieldsInfo?.fieldValue">
          {{ fieldsInfo?.fieldValue }}
        </xl-dot>
        <template v-else>{{ fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}</template>
      </template>

      <!--线索、线索池、客户 客户级别 -->
      <template v-else-if="fieldsInfo?.fieldKey == 'customerLevel'">
        <jw-tag bordered size="small" :color="levelColors[fieldsInfo?.fieldValue]" v-if="fieldsInfo?.fieldValue">
          {{ fieldsInfo?.fieldValue }}
        </jw-tag>
        <template v-else>{{ fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}</template>
      </template>

      <!--线索、线索池 是否为重点客户 -->
      <template v-else-if="fieldsInfo?.fieldKey == 'isImportant'">
        <jw-tag v-if="fieldsInfo.fieldValue == '是'" color="magenta" size="small">{{ $t('重点') }}</jw-tag>
        <template v-else>{{ fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}</template>
      </template>

      <!-- 成交状态 -->
      <template v-else-if="fieldsInfo?.fieldKey == 'isDealt'">
        <template v-if="fieldsInfo.fieldValue">
          <jw-tag size="small" class="custom-name-tag-width-tag" v-if="userInfo?.orgId == huaYingOrdId" :color="fieldsInfo.fieldValue == '出资一次' || fieldsInfo.fieldValue == '出资多次' ? 'green' : 'pinkpurple'">{{ $t(fieldsInfo.fieldValue) }}</jw-tag>
          <jw-tag size="small" class="custom-name-tag-width-tag" v-else :color="fieldsInfo.fieldValue == '成交一次' || fieldsInfo.fieldValue == '成交多次' ? 'green' : 'pinkpurple'">{{ $t(fieldsInfo.fieldValue) }}</jw-tag>
        </template>
        <template v-else>{{ fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}</template>
      </template>

      <!-- e签宝签约状态 -->
      <template v-else-if="fieldsInfo?.fieldKey == 'esignStatus'">
        <jw-space v-if="fieldsInfo?.fieldValue" size="large">
          <jw-tag size="small" :color="eSignTagColor(fieldsInfo?.fieldValue)">{{ fieldsInfo?.fieldValue }}</jw-tag>
          <jw-button v-if="fieldsInfo?.fieldValue == '失败' || fieldsInfo?.fieldValue == '过期'" size="mini" type="outline" @click.stop="startSigning(fieldsInfo)" :loading="data.activeId == fieldsInfo?.row?.id && data.signLoading">发起签署</jw-button>
        </jw-space>
        <span v-else>{{ fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}</span>
      </template>

      <!-- 生命状态 -->
      <xl-status v-else-if="fieldsInfo?.fieldType === 4 && fieldsInfo?.fieldKey === 'status'" :status="fieldsInfo.fieldValue" :statusOrigin="fieldsInfo.statusOrigin" />
      <!-- 线索池 线索状态 -->
      <template v-else-if="fieldsInfo?.fieldType === 4 && fieldsInfo?.fieldKey === 'clueStatus'">
        <jw-tag v-if="fieldsInfo.fieldValue == '已转化'" color="green">{{ fieldsInfo.fieldValue }}</jw-tag>
        <jw-tag v-else-if="fieldsInfo.fieldValue == '已领取'" color="blue">{{ fieldsInfo.fieldValue }}</jw-tag>
        <jw-tag v-else color="orange">{{ fieldsInfo.fieldValue }}</jw-tag>
      </template>

      <!-- 税率 -->
      <template v-else-if="fieldsInfo.entity == 4 && fieldsInfo?.fieldType === 4 && fieldsInfo?.fieldKey === 'taxRate'">
        {{ fieldsInfo.fieldValue ? tools.getPercentage(fieldsInfo.fieldValue, 0) + '%' : fieldsInfo?.showEmptyType ? fieldsInfo?.showEmptyType : '-' }}
      </template>

      <!-- 其他所有类型的标签字段 -->
      <ly-tag-fields v-else :isList="params.sourceType" :fieldValue="fieldsInfo.fieldValue" :fieldName="fieldsInfo?.fieldName" :fieldKey="fieldsInfo?.fieldKey" :styleInfo="fieldsInfo?.fieldExt" :record="fieldsInfo?.row" :fieldType="fieldsInfo?.fieldType" />
    </template>
  </div>
</template>

<script setup>
import { computed, reactive, inject } from 'vue';
import { useUserStore } from '@/store';
import { contractService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';
import { levelColors, adviceColors, huaYingOrdId } from '@/utils/const';

const { t } = useI18n();

const { userInfo } = useUserStore(); //用户信息
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});

const refreshList = inject('listSort')?.refreshList;
const fieldsInfo = computed(() => props.params);
const data = reactive({
  activeId: null,
  signLoading: false
});

// e签宝标签颜色
const eSignTagColor = (v) => {
  if (v === '失败') {
    // value==-3
    return 'magenta';
  } else if (v === '未发起') {
    // value==-1
    return 'purple';
  } else if (v === '签署中') {
    // value==-1
    return 'orange';
  } else if (v === '已签署') {
    // value==2
    return 'green';
  } else if (v === '过期') {
    // value==5
    return 'gray';
  } else if (v === '拒签') {
    // value==7
    return 'magenta';
  }
};

//合同发起签署
const startSigning = async (record) => {
  data.activeId = record?.row?.id;
  data.signLoading = true;
  try {
    const json = await contractService.startSigning({ id: record.row.id });
    if (json.error) {
      Message.error(json.error?.msg || t('操作失败'));
    } else {
      Message.success(t('签署成功'));
      refreshList(); //回调刷新列表
    }
    data.signLoading = false;
  } catch (e) {
    console.log(e);
    data.signLoading = false;
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
</script>
<style scoped lang="less">
@import './select.less';
</style>
